import { Meta } from '@weblite-wapps/protocol'

const awaitingParentResolvers: Record<string, (value: unknown) => void> = {}

export const registerAwaitingParent = (parent: Meta) => {
  const { wappSessionId } = parent
  if (awaitingParentResolvers[wappSessionId]) return

  return new Promise(resolve => {
    awaitingParentResolvers[wappSessionId] = resolve
  })
}

export const resolveAwaitingParent = (
  wappSessionId: string,
  output: unknown,
) => {
  awaitingParentResolvers[wappSessionId]?.(output)
  delete awaitingParentResolvers[wappSessionId]
}
